module.exports = __webpack_public_path__ + "images/emoji/large_blue_circle.c7fab3e315ba2d538a44.png";